// =============================================
// COMPONENTE: MOBILE TOOLBAR
// =============================================
// Arquivo: MobileToolbar.tsx
// Descrição: Toolbar otimizada para mobile com botões grandes
// =============================================

import React from 'react';
import './MobileToolbar.css';

interface MobileToolbarProps {
  isOpen: boolean;
  onToggle: () => void;
  onAddNode: (type: string) => void;
  selectedNode: any;
  onEditNode: () => void;
  onDeleteNode: () => void;
  onSave: () => void;
}

const MobileToolbar: React.FC<MobileToolbarProps> = ({
  isOpen,
  onToggle,
  onAddNode,
  selectedNode,
  onEditNode,
  onDeleteNode,
  onSave
}) => {
  const [expandedCategory, setExpandedCategory] = React.useState<string | null>('core');

  const nodeCategories = [
    {
      id: 'core',
      label: 'Core',
      nodes: [
        { type: 'start', icon: 'fa-play-circle', label: 'Início', color: '#48bb78' },
        { type: 'webhook_trigger', icon: 'fa-bolt', label: 'Webhook', color: '#8b5cf6' },
        { type: 'scheduler', icon: 'fa-clock', label: 'Agendamento', color: '#84cc16' },
        { type: 'end', icon: 'fa-flag-checkered', label: 'Fim', color: '#fc8181' }
      ]
    },
    {
      id: 'messaging',
      label: 'Mensagens',
      nodes: [
        { type: 'message', icon: 'fa-comment-dots', label: 'Mensagem', color: '#25D366' },
        { type: 'whatsapp_advanced', icon: 'fa-whatsapp', label: 'WhatsApp+', color: '#25D366' },
        { type: 'email', icon: 'fa-envelope', label: 'Email', color: '#0ea5e9' },
        { type: 'input', icon: 'fa-keyboard', label: 'Entrada', color: '#4299e1' },
        { type: 'menu', icon: 'fa-list', label: 'Menu', color: '#a855f7' }
      ]
    },
    {
      id: 'logic',
      label: 'Lógica',
      nodes: [
        { type: 'condition', icon: 'fa-code-branch', label: 'Condição', color: '#ed8936' },
        { type: 'switch', icon: 'fa-random', label: 'Switch', color: '#f97316' },
        { type: 'set_variables', icon: 'fa-edit', label: 'Variáveis', color: '#8b5cf6' },
        { type: 'loop', icon: 'fa-sync-alt', label: 'Loop', color: '#ec4899' },
        { type: 'error_handler', icon: 'fa-exclamation-triangle', label: 'Try/Catch', color: '#ef4444' },
        { type: 'javascript_function', icon: 'fa-code', label: 'JavaScript', color: '#f59e0b' }
      ]
    },
    {
      id: 'integrations',
      label: 'Integrações',
      nodes: [
        { type: 'http_request', icon: 'fa-globe', label: 'HTTP', color: '#3b82f6' },
        { type: 'internal_api', icon: 'fa-server', label: 'API Interna', color: '#06b6d4' },
        { type: 'database', icon: 'fa-database', label: 'Banco de Dados', color: '#64748b' },
        { type: 'action', icon: 'fa-cog', label: 'Ação', color: '#9f7aea' }
      ]
    }
  ];

  const toggleCategory = (categoryId: string) => {
    setExpandedCategory(expandedCategory === categoryId ? null : categoryId);
  };

  return (
    <>
      {/* Botão Flutuante */}
      <button className="mobile-fab" onClick={onToggle}>
        <i className={`fas ${isOpen ? 'fa-times' : 'fa-plus'}`}></i>
      </button>

      {/* Overlay */}
      {isOpen && <div className="mobile-toolbar-overlay" onClick={onToggle}></div>}

      {/* Toolbar */}
      <div className={`mobile-toolbar ${isOpen ? 'open' : ''}`}>
        <div className="mobile-toolbar-header">
          <h3>Adicionar Nó</h3>
          <button className="close-btn" onClick={onToggle}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="mobile-toolbar-content">
          {/* Adicionar Nós - Por Categoria */}
          <div className="toolbar-section">
            {nodeCategories.map((category) => (
              <div key={category.id} className="node-category">
                <button
                  className="category-header"
                  onClick={() => toggleCategory(category.id)}
                >
                  <span>{category.label}</span>
                  <i className={`fas fa-chevron-${expandedCategory === category.id ? 'up' : 'down'}`}></i>
                </button>
                {expandedCategory === category.id && (
                  <div className="node-types-grid">
                    {category.nodes.map((nodeType) => (
                      <button
                        key={nodeType.type}
                        className="node-type-btn"
                        onClick={() => onAddNode(nodeType.type)}
                        style={{ borderColor: nodeType.color }}
                      >
                        <div
                          className="node-type-icon"
                          style={{ background: nodeType.color }}
                        >
                          <i className={`fas ${nodeType.icon}`}></i>
                        </div>
                        <span>{nodeType.label}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Ações do Nó Selecionado */}
          {selectedNode && (
            <div className="toolbar-section">
              <h4>Nó Selecionado</h4>
              <div className="selected-node-actions">
                <button className="action-btn edit-btn" onClick={onEditNode}>
                  <i className="fas fa-edit"></i>
                  <span>Editar</span>
                </button>
                <button className="action-btn delete-btn" onClick={onDeleteNode}>
                  <i className="fas fa-trash"></i>
                  <span>Deletar</span>
                </button>
              </div>
            </div>
          )}

          {/* Ação Global */}
          <div className="toolbar-section">
            <button className="save-flow-btn" onClick={onSave}>
              <i className="fas fa-save"></i>
              <span>Salvar Fluxo</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileToolbar;
